export * from "./HeavyContent";
